import 'core-js/stable'
import '@/styles/gear-vue3'
import '@/styles/index.less'
// @ts-ignore
import initReportPlugin from '@jdt-jinke/vue-plugin-init-report'
import router from '@/router'
import App from './App.vue'
import { Lazyload } from '@jdt-jinke/jdtm/es'

// 创建应用实例
const app = createApp(App)

// 使用路由
app.use(router)

// 使用sgm上报插件
app.use(initReportPlugin, {
  domainList: ['pay-user.jd.com', 'pay-static2.jd.com', 'pay-static.jd.com']
})

// 注册组件懒加载
app.use(Lazyload, {
  lazyComponent: true
})

// 实例挂载
app.mount('#app')

// UDC 插件安装
// modules.forEach(m => m.install(app))

// Dialog.install(app)
// Toast.install(app)
// Loading.install(app)
